// @flow

import React from 'react'
import { Route /* ,Switch */ } from 'react-router-dom'
import { Dimmer, Loader } from 'semantic-ui-react'
import Loadable from 'react-loadable'
import PageNotFound from 'screens/PageNotFound'
// import Metrics from 'components/metrics/examples'
// import Accounts from './screens/Accounts'

const DimLoader = () => (
  <Dimmer>
    <Loader />
  </Dimmer>
)

const makeLoadable = opts =>
  Loadable({
    loading: DimLoader,
    ...opts
  })

const LoadableFlyers = makeLoadable({
  loader: () => import('./screens/Flyers')
})
// const LoadableEntranceContainer = makeLoadable({loader: () => import('./screens/Entrance')})
// const LoadableTryPeachjarFreeContainer = makeLoadable({loader: () => import('./screens/TryPeachjarFree')})
// const LoadableMetrics = makeLoadable({loader: () => import('./screens/Metrics')})
// const LoadableTemplateBuilder = makeLoadable({loader: () => import('./screens/TemplateBuilder')})
// const LoadableAccounts = makeLoadable({loader: () => import('./screens/Accounts')})

const App = () => (
  <div className="app">
    <Route path="/" exact render={() => <PageNotFound />} />
    <Route path="/flyers" component={LoadableFlyers} />
    {/* <Route path="/metrics" component={Metrics} /> */}
    {/* <Route path="/accounts" component={Accounts} / */}
  </div>
)

export default App



// WEBPACK FOOTER //
// ./src/App.js